import script from "./PitchHolder.vue?vue&type=script&setup=true&lang=js"
export * from "./PitchHolder.vue?vue&type=script&setup=true&lang=js"

import "./PitchHolder.vue?vue&type=style&index=0&id=13952842&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13952842"]])

export default __exports__